<template>
  <component
    :is="location === 'Subscription Page' ? 'v-container' : 'pt-sheet'"
  >
    <v-row class="px-12">
      <v-col>
        <h1 class="h1-desktop-36">Employee Exclusion Monitoring</h1>
        <div class="h3-desktop-regular-20 mt-4">
          <p>
            As a healthcare vendor, CMS regulations and your clients require
            ongoing employee monitoring for exclusions. Our secure service
            automates exclusion tracking for your team and provides the proof
            your clients need—making compliance effortless.
          </p>
          <p>
            Your first month is only $25, regardless of team size. After the
            first month, pricing adjusts based on the size of your employee
            population. Save time, reduce risk, and stay compliant—all in one
            simple solution!
          </p>
        </div>
      </v-col>
    </v-row>
    <v-row justify="space-between px-12 mb-8">
      <v-col class="text-center" cols="12" md="4">
        <div class="icon-container">
          <v-icon>
            $calendarIcon
          </v-icon>
        </div>
        <div class="body-desktop-large-bold-18 mt-4">
          <p>Pay $25 to Start Your First Month</p>
        </div>
      </v-col>
      <v-col class="text-center" cols="12" md="4">
        <div class="icon-container">
          <v-icon>
            $uploadIcon
          </v-icon>
        </div>
        <div class="body-desktop-large-bold-18 mt-4">
          <p>Upload Your Employees for Monitoring</p>
        </div>
      </v-col>
      <v-col class="text-center" cols="12" md="4">
        <div class="icon-container">
          <v-icon>
            $peopleIcon
          </v-icon>
        </div>
        <div class="body-desktop-large-bold-18 mt-4">
          Scaled Pricing for Subsequent Months
        </div>
        <div class="body-desktop-medium-regular-16">
          <span class="body-desktop-medium-bold-16 colorPtRoyal500--text"
            >$25/month</span
          >
          for up to 100 employees.
        </div>
        <div class="body-desktop-medium-regular-16">
          <span class="body-desktop-medium-bold-16 colorPtRoyal500--text"
            >$50/month</span
          >
          for 101-250 employees.
        </div>
        <div class="body-desktop-medium-regular-16">
          <span class="body-desktop-medium-bold-16 colorPtRoyal500--text"
            >$50/month + $0.10</span
          >
          per additional employee over 250.
        </div>
      </v-col>
    </v-row>
    <v-row class="px-12">
      <v-col>
        <div class="text-center">
          <v-btn
            depressed
            color="primary"
            :to="{
              name: 'subscriptionPayment',
              params: {
                type: 'VP_EMPLOYEE_MONITORING',
                backNavigationTo: { name: 'employees' }
              }
            }"
            class="pt-primary"
            :block="$vuetify.breakpoint.xsOnly"
            @click.native="
              logEvent('Clicked button to upgrade to employee monitoring', {
                Location: location || 'Unknown'
              })
            "
          >
            Start Employee Monitoring
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <slot></slot>
  </component>
</template>

<script>
import PtSheet from "@/components/PtSheet.vue";

export default {
  name: "EmployeeMonitoringPitch",
  props: {
    location: String
  },
  components: {
    PtSheet
  }
};
</script>

<style lang="scss" scoped>
.icon-container {
  height: 100px;
}

.v-icon {
  height: 100%;
}
</style>
